import {
  Component,
  EventEmitter,
  Input,
  isDevMode,
  OnInit,
  Output,
} from '@angular/core';
import { accordion } from '@zipari/design-system';
import { SearchService } from '../search.service';
import { SearchBarConfig, SearchBarTab } from './search-bar-config.interface';
import { ZipGoogleMapService } from '../../map/map.service';

@Component({
  animations: [accordion],
  selector: 'search-bar',
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.scss'],
})
export class SearchBarComponent implements OnInit {
  @Input() config: SearchBarConfig;
  @Input() initialZipcode: number;
  @Input() initialPCCDistance: string;
  @Output() search = new EventEmitter<any>();
  @Output() initialDistance = new EventEmitter<any>();
  @Output() distanceChanged = new EventEmitter<any>();
  @Output() nameSearch = new EventEmitter<any>();

  searchConfig;
  name;
  lat;
  lng;

  linkedTab: SearchBarTab;
  selectedDistance: number;
  linkedLabel: string;
  linkedOptions: Array<string>;
  providerSearchBarText: string;

  constructor(
    private zipMapService: ZipGoogleMapService,
    public searchService: SearchService,
  ) {}

  get hasProviderResults(): boolean {
    return !!this.searchService.hasProviderResults;
  }

  get subHeaderText(): string {
    if (this.config.isDynamic) {
      const subHeaderText: string = this.hasProviderResults
        ? 'Find your preferred primary care clinic'
        : 'No Primary Care Clinics Found with Your Current Search Criteria';

      return subHeaderText;
    }
    return this.config.subHeader;
  }

  ngOnInit() {
    try {
      if (!this.config) {
        throw this.cannotInitError('SearchBarConfig not found');
      }
      this.initFields(this.config);
    } catch (error) {
      if (isDevMode()) {
        throw this.cannotInitError(error);
      }
    }
  }

  cannotInitError = (error: any): Error =>
    Error(`SearchBarComponent cannot initialize: ${error}`);

  initFields(config: SearchBarConfig): void {
    this.searchConfig = config.searchConfig;
    this.selectedDistance = this.initialPCCDistance
      ? parseInt(this.initialPCCDistance)
      : this.searchConfig.defaultDistance;
    this.initialDistance.emit(this.selectedDistance);
    this.providerSearchBarText = this.searchConfig.providerSearchBarText;
  }

  onWithinDistanceChange(distance: string) {
    const number: string = distance.match(/\d+/)[0];
    this.distanceChanged.emit(number);
  }

  updateCurrentValue = (nextValue: any) => (this.initialZipcode = nextValue);

  getLatLng(address: string) {
    this.zipMapService.GetLatLngFromAddress(address).then((latlng) => {
      this.lat = latlng.lat();
      this.lng = latlng.lng();
      const emitLatLng = {
        lat: this.lat,
        lng: this.lng,
        zipcode: address,
      };
      this.search.emit(emitLatLng);
    });
  }

  onSearchAreaInputEnter(inputValue) {
    this.getLatLng(inputValue);
    this.updateCurrentValue(inputValue);
  }

  onSearchProviderName($event) {
    this.name = $event;
    this.nameSearch.emit(this.name);
  }

  // TODO(cstroh): We don't have geolocation enabled for our Google Maps API key https://jira.zipari.net/browse/FE-1078
  onUseMyCurrentLocationClick() {
    // console.log('use current location');
    // this.updateCurrentValue();
  }
}

interface Query {
  parameter: any;
  value: any;
}
